// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ctm-export-select-row[data-v-a8ff199a]{display:flex;align-items:center;gap:12px}.ctm-export-select[data-v-a8ff199a]{width:400px;max-width:100%}.ctm-hint[data-v-a8ff199a]{margin-top:6px;font-size:12px;color:#9ca3af}.ctm-hint--info[data-v-a8ff199a]{color:#6b7280}", ""]);
// Exports
module.exports = exports;
